const debug = false;
const API_BASE = debug ? 'http://localhost:8080' : '';

export { debug, API_BASE };
